/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){.faq-answer-dialog{width:100%}}@media screen and (min-width:600px){.faq-answer-dialog{width:720px}}.faq-answer-dialog .mat-dialog-container{padding:0}.faq-answer-dialog .dialog-content-wrapper{max-height:85vh;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}"];
export { styles as styles };
